// extracted by mini-css-extract-plugin
export default {"waveformContainer":"TimelineWaveform_waveformContainer__DeOgE"};